module.exports = "/images/demo_multi_tally.png?d503fd96ce79863108c402de0608b0c2";